import React from 'react';
import LeftBar from '../../Components/LeftBar';
import Dashnav from '../../Components/Dashnav';
import ViewVendorComp from './ViewVendorComp';

function ViewVendor() {
  return (
    <div className="mainContainer">
      <LeftBar />
      <div className="theMainContainer">
        <Dashnav />
        <ViewVendorComp />
      </div>
    </div>
  );
}

export default ViewVendor;
